$(document).on('click', '.main_wear_it .custom-add-to-cart .btn-add', function () {
  var linee = $(this).data('id');
  console.log(linee);
  addItemNeww(linee)
});

function addItemNeww(linee) {
  let data = {
   'items': [{
    'id': linee,
    'quantity': 1
    }]
  };
  fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    })
    .then((response) => response.json())
    .then((data) => {
        load_cart();
      setTimeout(()=>{
          $('body').addClass('open-drawer')
      },500);

    })
    .catch((error) => {
        console.error('Error:', error);
  });
}
// setInterval(function(){
//   if(document.querySelector('.drawer-footer') != null){
// var toRemoveHeights = parseInt(document.querySelector('.drawer-footer').offsetHeight) + parseInt(document.querySelector('.drawer-header').offsetHeight) + 26;
// var remainingHeights = parseInt(window.innerHeight) - toRemoveHeights;
  
// document.querySelector('.drawer-middle').style.height = remainingHeights + 'px';
//     }
// }, 100);
function load_cart(){
  fetch(window.Shopify.routes.root +'?section_id=cart-drawer')
  .then((response) => response.text())
  .then((responseText) => {
    const cartid = 'cart-drawer';
    const html = new DOMParser().parseFromString(responseText, 'text/html')  
    const destination = document.querySelector('.cart-sidebar');
    const source = html.getElementById(cartid);
    if (source && destination) destination.innerHTML = source.innerHTML;
    document.querySelectorAll('.item-remove').forEach(function(cartRemove){
      var data_line = cartRemove.dataset.line;      
      cartRemove.addEventListener('click',(evt) => removeItem(data_line));
    });
    document.querySelectorAll('.header-cart').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
      if($(window).width() < 768){
        $('body').attr( 'data-pos', $(window).scrollTop()); // get actual scrollpos
         $('body').scrollTop( $('body').attr( 'data-pos' ) ); 
        $('body').addClass('locked'); // add class to body
      }

        document.querySelector('body').classList.add('open-drawer');
        document.querySelector('body').classList.remove('open-menu','open-search','open-sort','open-filter');
         $('.shiping_info .list').infiniteslide({
          'speed': 100,
          'direction': 'left',
          'pauseonhover': true,
          'responsive': false,
          'clone': 2
          });
      });
    });
    document.querySelectorAll('.overlay-box,.cart-drawer-close').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
         if($(window).width() < 768){
          $("body").removeClass('locked');
          $(window).scrollTop( $('body').attr( 'data-pos' ));
          }
        setTimeout(function() {
          document.querySelector('body').classList.remove('open-drawer','open-menu','open-search','open-sort','open-filter');
        },200)
      });
    });
    const url = '/cart.js';
    fetch(url)
    .then((resp) => resp.json())
    .then(function(data){

      let freeProdEl = document.querySelector('.cd-free-prod');
      let freeProdId = parseInt(freeProdEl.getAttribute('data-id'));
      let freeProdThreshold = parseInt(freeProdEl.getAttribute('data-free-price'));
      let freeProdPrice = parseInt(freeProdEl.getAttribute('data-price'));
      
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          let freeGiftItem = cart.items.find(item => item.id === freeProdId);
          let isFreeProductInCart = !!freeGiftItem;
      
          let adjustedTotalPrice = isFreeProductInCart
            ? cart.total_price - freeGiftItem.final_line_price
            : cart.total_price;
      
          if (adjustedTotalPrice >= freeProdThreshold && !isFreeProductInCart) {
            // Add free product
            let payload = {
              id: freeProdId,
              quantity: 1
            };
      
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(payload),
            })
            .then(response => response.json())
            .then(data => {
              console.log('Free product added');
              load_cart();
              setTimeout(() => {
                document.body.classList.add('open-drawer');
              }, 500);
            })
            .catch(error => {
              console.error('Error:', error);
            });
      
          } else if (
            adjustedTotalPrice < freeProdThreshold &&
            isFreeProductInCart &&
            freeGiftItem.final_line_price === 0
          ) {
            // Remove free product
            const freeGiftLineIndex = cart.items.findIndex(item => item.id === freeProdId);
      
            if (freeGiftLineIndex !== -1) {
              const payload = {
                line: freeGiftLineIndex + 1,
                quantity: 0
              };
      
              fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
              })
              .then(response => response.json())
              .then(data => {
                console.log('Free product removed');
                load_cart();
              })
              .catch(error => {
                console.error('Error:', error);
              });
            }
          }
        });



      // let freeProdEl = document.querySelector('.cd-free-prod');
      // let freeProdId = parseInt(freeProdEl.getAttribute('data-id'));
      // let freeProdThreshold = parseInt(freeProdEl.getAttribute('data-free-price'));
      // let freeProdPrice = parseInt(freeProdEl.getAttribute('data-price'));
      // let hasFreeGiftClass = document.querySelector('.middle-top').classList.contains('has_free_prod');
      // let freeGiftItem = data.items.find(item => item.id == freeProdId);
      // let isFreeProductInCart = !!freeGiftItem;
      // let adjustedTotalPrice = hasFreeGiftClass ? data.total_price - freeProdPrice : data.total_price;
      // if(adjustedTotalPrice >= freeProdThreshold && !isFreeProductInCart){
      //   let payload = {
      //     id: freeProdId,
      //     quantity: 1,
      //     properties: {
      //       // freegift: 'true'
      //       freegift: 'FREE GIFT'
      //     }
      //   };
      //   fetch('/cart/add.js', {
      //     method: 'POST',
      //     headers: { 'Content-Type': 'application/json' },
      //     body: JSON.stringify(payload),
      //   })
      //   .then(response => response.json())
      //   .then(data => {
      //     console.log('Free product added');
      //     load_cart();
      //     setTimeout(() => {
      //       document.body.classList.add('open-drawer');
      //     }, 500);
      //   })
      //   .catch(error => {
      //     console.error('Error:', error);
      //   });
      // }
      // if (adjustedTotalPrice < freeProdThreshold && isFreeProductInCart && hasFreeGiftClass) {
      //   fetch('/cart.js')
      //     .then(response => response.json())
      //     .then(cart => {
      //       const freeGiftLineIndex = cart.items.findIndex(item =>
      //         item.id == freeProdId &&
      //         item.properties &&
      //         item.properties.freegift === 'FREE GIFT'
      //       );
      
      //       if (freeGiftLineIndex !== -1) {
      //         const payload = {
      //           line: freeGiftLineIndex + 1, // Shopify cart lines are 1-based
      //           quantity: 0
      //         };
      
      //         fetch('/cart/change.js', {
      //           method: 'POST',
      //           headers: { 'Content-Type': 'application/json' },
      //           body: JSON.stringify(payload),
      //         })
      //         .then(response => response.json())
      //         .then(data => {
      //           console.log('Free product removed');
      //           load_cart();
      //         })
      //         .catch(error => {
      //           console.error('Error:', error);
      //         });
      //       }
      //     });
      // }
      var cart_count = data.item_count;
      var option_color = '';
      var option_size = '';
      if(data.items.length > 0 && data.items[0].final_price != undefined){
        var option_price = Shopify.formatMoney(data.items[0].final_price); 
        data.items[0].options_with_values.forEach(function (option) {
          if(option.name == "Color") {
            option_color = option.value;
          }
          if(option.name == "Size") {
            option_size = option.value; 
          }
        });
      }
      if(cart_count>0){
      	document.querySelectorAll('.header-cart.none_991 .cart-count').forEach( c_count =>{
          c_count.innerHTML = '(' + cart_count + ')';
        })
      	document.querySelectorAll('.header-cart.block_991 .cart-count').forEach( c_count =>{
          c_count.innerHTML = cart_count;
        })
        document.querySelector('.header-cart.block_991 .cart-count').classList.add('active');
      }else{
      	document.querySelectorAll('.header-cart.none_991 .cart-count').forEach( c_count => {
          c_count.innerHTML = '(0)';
        })
      	document.querySelectorAll('.header-cart.block_991 .cart-count').forEach( c_count => {
          c_count.innerHTML = 0;
        })
        document.querySelector('.header-cart.block_991 .cart-count').classList.remove('active');
      }
    })
    .catch(function(error) {
      console.log(error);
    })
  });
}
load_cart();
function removeItem(data_line){
  const data = {'line': data_line ,'quantity': 0 };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  .then((response) => response.json())
  .then((data) => {
    load_cart();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}


$(document).ready(function () {

  $(document).on('click', '.main-upsell .add-btn', function () {
    $(this).hide();
    $(this).parents('.top-upsell').next('.bottom-upsell').slideDown();
  });
  $(document).on('click', '.upsell-var .var', function () {
    $(this).addClass('active').siblings().removeClass('active');
    var id = $(this).data('id');
    $(this).parents('.upsell-var').next().attr("data-id",id);
  });
  $(document).on('click', '.singal-upsell .main-btn', function () {
    var line = $(this).data('id');
    addItemNew(line)
  });

  function addItemNew(line) {
    let data = {
     'items': [{
      'id': line,
      'quantity': 1
      }]
    };
    fetch('/cart/add.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
      })
      .then((response) => response.json())
      .then((data) => {
          load_cart();
      })
      .catch((error) => {
          console.error('Error:', error);
    });
  }

  

  $(document).on('change','.center_qty .cart_qty', function() {
   var new_qty = $(this).val();
    var line = $(this).parent('.center_qty').siblings('.item_minus').data('line-item')
   addItem(line,new_qty); 
 });

  $(document).on('click', '.item_plus', function () {
      setTimeout(() => {
        $('.shiping_info .list').infiniteslide({
          'speed': 100,
          'direction': 'left',
          'pauseonhover': true,
          'responsive': false,
          'clone': 2
        });
      }, "1500")
      $(this).prev('.center_qty').find('input').val(+$(this).prev('.center_qty').find('input').val() + 1);
      var new_line = $(this).data('line-item')
      var new_qty = $(this).closest('.main_qty').find('input.cart_qty').val();
      addItem(new_line, new_qty);
  });
  $(document).on('click', '.item_minus', function () {
      setTimeout(() => {
        $('.shiping_info .list').infiniteslide({
          'speed': 100,
          'direction': 'left',
          'pauseonhover': true,
          'responsive': false,
          'clone': 2
        });
      }, "1500")
      if ($(this).next('.center_qty').find('input').val() > 0) $(this).next('.center_qty').find('input').val(+$(this).next('.center_qty').find('input').val() - 1);
      var new_line = $(this).data('line-item')
      var new_qty = $(this).closest('.main_qty').find('input.cart_qty').val();
      addItem(new_line, new_qty);
  });

// ===
  if($(".quantity-box input")) {
    $(document).on('change','.quantity-box input', function() {
      var new_line = $(this).attr("data-index");
      var new_qty = $(this).val();
      addItem(new_line, new_qty);
    });
  }
  // var quanity_box = document.querySelectorAll('.quantity-box');
  // var update_button = document.querySelector('.button-update');
  // if(quanity_box){
  //   quanity_box.forEach(function(quantitywrap){
  //     var quantity_minus = quantitywrap.querySelector(".quantity-minus");
  //     var quantity_add = quantitywrap.querySelector(".quantity-plus");
  //     var quantity = quantitywrap.querySelector(".quantity-input input");
  //     const minimum = 0;
  //     if(quantity_minus){
  //       quantity_minus.addEventListener("click", function(){
  //         if (quantity.value <= minimum) {
  //           quantity_minus.disabled = true;
  //           return;
  //         } else {
  //           quantity_minus.disabled = false;
  //         }
  //         quantity.value--;
  //         if(update_button){
  //           update_button.click();
  //         }
  //       });
  //     }
  //     if(quantity_add){
  //       quantity_add.addEventListener("click", function() {
  //         if (quantity.value > minimum) {
  //           quantity_minus.disabled = false;
  //         }
  //         quantity.value++;
  //         if(update_button){
  //           update_button.click();
  //         }
  //       });
  //     }
  //   });
  // }
  // ===

  
  function addItem(new_line, new_qty) {
      const data = { 'line': new_line, 'quantity': new_qty };
      fetch('/cart/change.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
      })
      .then((response) => response.json())
      .then((data) => {
          load_cart();
      })
      .catch((error) => {
          console.error('Error:', error);
      });
  }

  // setInterval(function(){
  //   if(document.querySelector('.drawer-footer') != null){
  //   var toRemoveHeights = parseInt(document.querySelector('.drawer-footer').offsetHeight) + parseInt(document.querySelector('.drawer-header').offsetHeight) + 26;
  //   var remainingHeights = parseInt(window.innerHeight) - toRemoveHeights;
  //   document.querySelector('.drawer-middle').style.height = remainingHeights + 'px';
  //     }
  // }, 100);
  
})





var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "€{{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '€1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};














        